import { render, staticRenderFns } from "./DeliveryDetail.vue?vue&type=template&id=233da36f&scoped=true"
import script from "./DeliveryDetail.vue?vue&type=script&lang=js"
export * from "./DeliveryDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetail.vue?vue&type=style&index=0&id=233da36f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233da36f",
  null
  
)

export default component.exports